<script setup lang="ts">
definePageMeta({
  name: 'inspections-category-page',
  layout: 'default',
  hideDefaultTopNav: true,
})

const route = useRoute()
const is404 = ref(false)

/** 从路由段读取当前页码，缺省时回退到第一页。 */
const getRoutePage = () => {
  const page = route.params.page
  const pageValue = Array.isArray(page) ? page[0] : page
  const parsedPage = Number(pageValue)

  if (!Number.isFinite(parsedPage) || parsedPage < 1) {
    return 1
  }

  return Math.trunc(parsedPage)
}

/** 当前页码完全由路由驱动，确保客户端切换后数据依赖同步更新。 */
const currentPage = computed(() => getRoutePage())

/** 显式命中 `/page/1` 视为非规范第一页入口，需要展示假 404。 */
const isExplicitFirstPageRoute = computed(() => {
  const page = route.params.page
  const pageValue = Array.isArray(page) ? page[0] : page

  return pageValue === '1'
})

watchEffect(() => {
  is404.value = isExplicitFirstPageRoute.value
})
</script>

<template>
  <HeaderWikiBitPcTopNav :always-expand-search="true" :force-solid-background="true" />
  <CommonNotFound v-if="is404" />
  <SurveyInspectionListContent v-else :current-page="currentPage" />
</template>
